import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField, truckNumber } from "helpers/validators";
import { selectList as cargoOwnersList } from "sources/books/cargoOwners";

const config = {
    counterpartyIds: {
        label: "Перевозчик(и)",
        inputProps: { name: "counterpartyIds" },
        url: cargoOwnersList,
        propName: "name",
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
        components: { ValueContainer },
        ...defaultMultipleSelectProps,
    },
    number: {
        label: "Гос. номер",
        inputProps: { name: "number", placeholder: "А 111 АА / 777" },
        required: true,
        type: "carNumber",
        validators: [requiredField, truckNumber],
    },
    typeId: {
        label: "Тип ТС",
        inputProps: { name: "typeId" },
        dictionary: "carType",
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
    },
    brandTypeId: {
        label: "Марка ТС",
        inputProps: { name: "brandTypeId" },
        dictionary: "carBrandType",
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
